import { ref } from 'vue';

import FeedbackRepository from '@/features/feedback/api/FeedbackRepository';

/**
 * Who may open the feedback reporter.
 *
 * The verdict comes from the backend allowlist, NOT from `useFeatureFlags`:
 * that helper opens a flag to every super-user and to whole e-mail domains
 * (`INTERNAL_FEATURE_EMAIL_DOMAINS`), which is exactly the widening this
 * capability must not have. One source of truth, asked once per session, and
 * the same allowlist the submit endpoint enforces.
 */
const canSubmit = ref(false);
const loaded = ref(false);
let inFlight = null;

export function resetFeedbackAccess() {
  canSubmit.value = false;
  loaded.value = false;
  inFlight = null;
}

export function useFeedbackAccess() {
  async function refresh() {
    if (inFlight) return inFlight;
    inFlight = FeedbackRepository.capability()
      .then(({ data }) => {
        canSubmit.value = Boolean(data?.can_submit);
      })
      .catch(() => {
        // A failed probe means "no button", never "show it and hope": the
        // endpoint would refuse the submit anyway.
        canSubmit.value = false;
      })
      .finally(() => {
        loaded.value = true;
        inFlight = null;
      });
    return inFlight;
  }

  return { canSubmit, loaded, refresh };
}
